import(/* webpackMode: "eager" */ "/app/app/patyshiatsu/page.tsx");
